import React from 'react';
import '../styles/Membership.scss';

const Membership = () => {
    return (
        <section className="membership">
            <div className="container">
                <div className="cta-box">
                    <h2>Join the Inner Circle</h2>
                    <p>Get exclusive access to pre-launch bookings, zero-G training sessions, and VIP lounge access at all spaceports.</p>
                    <button className="btn-join">Become a Member</button>
                </div>
            </div>
        </section>
    );
};

export default Membership;
